// export const PAYMENT_STATUS = { 0: "Due", 1: "Settled", 2: "Cancelled", 3: "Refunded", 4: "Overdue" }
export const PAYMENT_STATUS_CLASSNAMES = { 0: "alert", 1: "completed", 2: "stale", 3: "pending", 4: "alert" }
export const DATA_API_PROPERTIES_KEY = "Payment";